export default class Timeline {
    constructor(element) {
        this.element = element;
        this.items = this.element.querySelectorAll('.timeline-item');
        this.progressLine = this.element.querySelector('.timeline-progress-line');
        this.init();
    }

    init() {
        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll.bind(this));

        const observerOptions = {
            root: null,
            threshold: 0.5
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                }
            });
        }, observerOptions);

        this.items.forEach(item => {
            observer.observe(item);
        });
    }

    handleScroll() {
        const rect = this.element.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const totalHeight = this.element.offsetHeight;

        let progress = (windowHeight / 2 - rect.top) / totalHeight;

        progress = Math.max(0, Math.min(1, progress));

        if (this.progressLine) {
            this.progressLine.style.height = `${progress * 100}%`;
        }
    }
}